// extracted by mini-css-extract-plugin
export default {"heading":"ReportingDetailsThemesEditTemplate_heading__buRba","buttonLink":"ReportingDetailsThemesEditTemplate_buttonLink__FMxGJ"};